import React, { useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
import Typography from '@material-ui/core/Typography';
import Container from '@material-ui/core/Container';
import TextField from '@material-ui/core/TextField';
import Box from '@material-ui/core/Box';
import { arrayToData25, throttle } from '../../../helpers/utils';
import dataCsv from './data.csv';
import { data } from './data'

const useStyles = makeStyles((theme) => ({
    table: {
        minWidth: 650,
    },
    paper: {
        display: 'flex',
        flexDirection: 'column',
        padding: 10,
        marginTop: 20,
        [theme.breakpoints.down('sm')]: {
            padding: 15,
            marginTop: 10,
        },
    },
    heading: {
        display: 'flex',
        justifyContent: 'space-between',
        [theme.breakpoints.down('md')]: {
            padding: 4,
            marginTop: 10,
            flexDirection: 'column',
        },
    },
    container: {
        [theme.breakpoints.down('sm')]: {
            paddingLeft: theme.spacing(1),
            paddingRight: theme.spacing(1),
        },
    },
    title: {
        [theme.breakpoints.down('md')]: {
            fontSize: '1.9rem',
        },
    },
    inputs: {
        display: 'flex',
        flexDirection: 'column',
        width: '260px',
    },
}));


export default function Members() {

    const [initialState, setMembersList] = useState(data)

    React.useEffect(() => {
        fetch(dataCsv)
            .then(response => response.text())
            .then(csvText => {
                // Robust CSV parser supporting quoted fields with commas and newlines
                function parseCSV(text) {
                    const rows = [];
                    let cur = '';
                    let row = [];
                    let inQuotes = false;
                    for (let i = 0; i < text.length; i++) {
                        const ch = text[i];
                        if (inQuotes) {
                            if (ch === '"') {
                                if (text[i + 1] === '"') { // escaped quote
                                    cur += '"';
                                    i++;
                                } else {
                                    inQuotes = false;
                                }
                            } else {
                                cur += ch;
                            }
                        } else {
                            if (ch === '"') {
                                inQuotes = true;
                            } else if (ch === ',') {
                                row.push(cur.trim());
                                cur = '';
                            } else if (ch === '\r') {
                                // ignore, handle on \n
                            } else if (ch === '\n') {
                                row.push(cur.trim());
                                rows.push(row);
                                row = [];
                                cur = '';
                            } else {
                                cur += ch;
                            }
                        }
                    }
                    // push last value
                    if (cur !== '' || inQuotes || row.length) {
                        row.push(cur.trim());
                        rows.push(row);
                    }
                    return rows;
                }

                try {
                    const parsed = parseCSV(csvText);
                    // remove header if it exists (first row contains "ФИО" etc.)
                    if (parsed.length && parsed[0].some(cell => /ФИО|Название доклада|Секция/i.test(cell))) {
                        parsed.shift();
                    }
                    // Filter out empty rows (no first cell)
                    const dataList = parsed.filter(r => r[0] && r[0].trim() !== '');
                    // Each row is expected in order: name, from, title, section
                    setMembersList(arrayToData25(dataList));
                    setMembers(arrayToData25(dataList));
                } catch (err) {
                    console.error('CSV parse error:', err);
                }
            })
            .catch(error => {
                console.error('Error fetching CSV:', error);
            });

    }, [])


    const classes = useStyles();
    const [members, setMembers] = useState(initialState);
    const filterMember = (e) => {
        const variant = e.currentTarget.id === 'search-name' ? 'name' : 'title';

        const value = e.target.value || '';
        const copy = [...initialState];
        if (variant === 'name') {
            setMembers(copy.filter((el) => el.name && el.name.search(new RegExp(value, 'ig')) !== -1));
        } else {
            setMembers(copy.filter((el) => el.title && el.title.search(new RegExp(value, 'ig')) !== -1));
        }
    };

    return (
        <Container maxWidth='lg' className={classes.container}>
            <Paper className={classes.paper}>
                <Box p={4} className={classes.heading}>
                    <Typography variant='h3' className={classes.title}>
                        Принятые заявки: {initialState.length}
                    </Typography>
                    <Box className={classes.inputs}>
                        <TextField
                            id='search-name'
                            size='small'
                            fullWidth
                            onChange={throttle(filterMember, 400)}
                            label='Поиск по фамилии'
                        />
                        <TextField
                            id='search-body'
                            size='small'
                            fullWidth
                            onChange={filterMember}
                            label='Поиск по названию'
                        />
                    </Box>
                </Box>
                <TableContainer component={Paper}>
                    <Table className={classes.table} aria-label='simple table'>
                        <TableHead>
                            <TableRow>
                                <TableCell align="left">№</TableCell>
                                <TableCell align="left">ФИО</TableCell>
                                <TableCell align="left">Место работы (учебы)</TableCell>
                                <TableCell align="left">Название доклада</TableCell>
                                <TableCell align="right">Секция</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {members.map((row, index) => (
                                <TableRow key={index}>
                                    <TableCell component='th' scope='row'>
                                        {index + 1}
                                    </TableCell>
                                    <TableCell component="th" scope="row">
                                        {row.name}
                                    </TableCell>
                                    <TableCell align="left">{row.from}</TableCell>
                                    <TableCell align="left">{row.title}</TableCell>
                                    <TableCell align="left">{row.section}</TableCell>
                                </TableRow>
                            ))}
                        </TableBody>
                    </Table>
                </TableContainer>
            </Paper>
        </Container>
    );
}
